import React, { useState } from 'react';
import './index.css';

const ContactForm = () => {
  // State for form input values
  const [formData, setFormData] = useState({
    name: '',
    subject: '',
    mobile: '',
    email: '',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission, such as sending data to an API
    console.log('Form data submitted: ', formData);
    // Reset form after submission
    setFormData({
      name: '',
      subject: '',
      mobile: '',
      email: '',
      message: ''
    });
  };

//   return (
//     <div className="contact-container">


// <form className='contact-form-container'>
// <h2 className='header-sec'>GET IN TOUCH</h2>
//       <div className="contact-form" onSubmit={handleSubmit}>
    
//         <div className="form-row">
//           <div className="form-group">
//             <label htmlFor="name">Name *</label>
//             <input
//               type="text"
//               id="name"
//               name="name"
//               value={formData.name}
//               onChange={handleChange}
//               placeholder="Enter your name"
//               required
//             />
//           </div>

//           <div className="form-group">
//             <label htmlFor="subject">Subject *</label>
//             <input
//               type="text"
//               id="subject"
//               name="subject"
//               value={formData.subject}
//               onChange={handleChange}
//               placeholder="Enter your subject"
//               required
//             />
//           </div>
//         </div>

//         <div className="form-row">
//           <div className="form-group">
//             <label htmlFor="mobile">Mobile *</label>
//             <input
//               type="tel"
//               id="mobile"
//               name="mobile"
//               value={formData.mobile}
//               onChange={handleChange}
//               placeholder="Enter your mobile"
//               required
//             />
//           </div>

//           <div className="form-group">
//             <label htmlFor="email">Email *</label>
//             <input
//               type="email"
//               id="email"
//               name="email"
//               value={formData.email}
//               onChange={handleChange}
//               placeholder="Enter your email"
//               required
//             />
//           </div>
//         </div>

//         <div className="form-group">
//           <label htmlFor="message">Message *</label>
//           <textarea
//             id="message"
//             name="message"
//             value={formData.message}
//             onChange={handleChange}
//             placeholder="Message ..."
//             required
//           />
//         </div>

        
//  </div>
//       <button type="submit" className="submit-btn">Submit</button>
    
//       </form>
//       <div className="map-container">
      
//         {/* Embed Google Map iframe */}
//         <iframe
//           width="100%"
//           height="450"
//           src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3806.3530824934405!2d78.4890415743578!3d17.442806683453846!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb9a10d7eab687%3A0x72205daaccbbc186!2sAshoka%20Bhoopal%20Chambers%2C%20Sardar%20Patel%20Rd%2C%20Kalasiguda%2C%20Secunderabad%2C%20Telangana%20500003!5e0!3m2!1sen!2sin!4v1734348718289!5m2!1sen!2sin"
//           style={{ border: 0 }}
//           allowFullScreen=""
//           loading="lazy"
//         ></iframe>

        
//       </div>
//     </div>
//   );


return (
  <div
    style={{
      minHeight: "100vh",
      background: "linear-gradient(to bottom right, #f8fafc, #dbeafe)",
      padding: "60px 20px",
    }}
  >
    <div
      style={{
        maxWidth: "1250px",
        margin: "0 auto",
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: "40px",
      }}
      className="contact-main-wrapper"
    >
      {/* LEFT SIDE FORM */}
      <div
        style={{
          background: "#ffffff",
          borderRadius: "24px",
          padding: "40px",
          boxShadow: "0 20px 50px rgba(0,0,0,0.08)",
          border: "1px solid rgba(255,255,255,0.6)",
        }}
      >
        <h2
          className="header-sec"
          style={{
            fontSize: "36px",
            fontWeight: "700",
            color: "#1e3a8a",
            marginBottom: "10px",
          }}
        >
          GET IN TOUCH
        </h2>

        <p
          style={{
            color: "#6b7280",
            marginBottom: "35px",
            fontSize: "16px",
          }}
        >
          Contact Lions Business Network – Multiple District 320
        </p>

        <form
          className="contact-form-container"
          onSubmit={handleSubmit}
        >
          <div
            className="form-row"
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "20px",
              marginBottom: "20px",
            }}
          >
            <div className="form-group">
              <label
                htmlFor="name"
                style={{
                  display: "block",
                  marginBottom: "8px",
                  fontWeight: "600",
                  color: "#374151",
                  fontSize: "14px",
                }}
              >
                Name *
              </label>

              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Enter your name"
                required
                style={{
                  width: "100%",
                  padding: "14px 16px",
                  border: "1px solid #d1d5db",
                  borderRadius: "12px",
                  fontSize: "15px",
                  outline: "none",
                  transition: "0.3s",
                  backgroundColor: "#fff",
                }}
              />
            </div>

            <div className="form-group">
              <label
                htmlFor="subject"
                style={{
                  display: "block",
                  marginBottom: "8px",
                  fontWeight: "600",
                  color: "#374151",
                  fontSize: "14px",
                }}
              >
                Subject *
              </label>

              <input
                type="text"
                id="subject"
                name="subject"
                value={formData.subject}
                onChange={handleChange}
                placeholder="Enter your subject"
                required
                style={{
                  width: "100%",
                  padding: "14px 16px",
                  border: "1px solid #d1d5db",
                  borderRadius: "12px",
                  fontSize: "15px",
                  outline: "none",
                  transition: "0.3s",
                  backgroundColor: "#fff",
                }}
              />
            </div>
          </div>

          <div
            className="form-row"
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "20px",
              marginBottom: "20px",
            }}
          >
            <div className="form-group">
              <label
                htmlFor="mobile"
                style={{
                  display: "block",
                  marginBottom: "8px",
                  fontWeight: "600",
                  color: "#374151",
                  fontSize: "14px",
                }}
              >
                Mobile *
              </label>

              <input
                type="tel"
                id="mobile"
                name="mobile"
                value={formData.mobile}
                onChange={handleChange}
                placeholder="Enter your mobile"
                required
                style={{
                  width: "100%",
                  padding: "14px 16px",
                  border: "1px solid #d1d5db",
                  borderRadius: "12px",
                  fontSize: "15px",
                  outline: "none",
                  transition: "0.3s",
                  backgroundColor: "#fff",
                }}
              />
            </div>

            <div className="form-group">
              <label
                htmlFor="email"
                style={{
                  display: "block",
                  marginBottom: "8px",
                  fontWeight: "600",
                  color: "#374151",
                  fontSize: "14px",
                }}
              >
                Email *
              </label>

              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Enter your email"
                required
                style={{
                  width: "100%",
                  padding: "14px 16px",
                  border: "1px solid #d1d5db",
                  borderRadius: "12px",
                  fontSize: "15px",
                  outline: "none",
                  transition: "0.3s",
                  backgroundColor: "#fff",
                }}
              />
            </div>
          </div>

          <div
            className="form-group"
            style={{
              marginBottom: "25px",
            }}
          >
            <label
              htmlFor="message"
              style={{
                display: "block",
                marginBottom: "8px",
                fontWeight: "600",
                color: "#374151",
                fontSize: "14px",
              }}
            >
              Message *
            </label>

            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              placeholder="Message ..."
              required
              rows={6}
              style={{
                width: "100%",
                padding: "16px",
                border: "1px solid #d1d5db",
                borderRadius: "12px",
                fontSize: "15px",
                outline: "none",
                resize: "none",
                transition: "0.3s",
                backgroundColor: "#fff",
              }}
            />
          </div>

          <button
            type="submit"
            className="submit-btn"
            style={{
              width: "100%",
              background:
                "linear-gradient(to right, #1e3a8a, #2563eb)",
              color: "#fff",
              border: "none",
              padding: "16px",
              borderRadius: "14px",
              fontSize: "16px",
              fontWeight: "600",
              cursor: "pointer",
              transition: "0.3s",
              boxShadow: "0 10px 25px rgba(37,99,235,0.25)",
            }}
          >
            Submit
          </button>
        </form>
      </div>

      {/* RIGHT SIDE */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "25px",
        }}
      >
        {/* CONTACT INFO CARD */}
        <div
          style={{
            background: "#ffffff",
            borderRadius: "24px",
            padding: "35px",
            boxShadow: "0 20px 50px rgba(0,0,0,0.08)",
          }}
        >
          <h3
            style={{
              fontSize: "28px",
              fontWeight: "700",
              color: "#111827",
              marginBottom: "30px",
            }}
          >
            Contact Information
          </h3>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "25px",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "18px",
              }}
            >
              <div
                style={{
                  width: "55px",
                  height: "55px",
                  borderRadius: "50%",
                  background:
                    "linear-gradient(to bottom right, #1e3a8a, #2563eb)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#fff",
                  fontSize: "22px",
                }}
              >
                ✉
              </div>

              <div>
                <h4
                  style={{
                    margin: 0,
                    fontSize: "18px",
                    color: "#111827",
                    marginBottom: "4px",
                  }}
                >
                  Email
                </h4>

                <p
                  style={{
                    margin: 0,
                    color: "#6b7280",
                  }}
                >
                  lbnmd320@gmail.com
                </p>
              </div>
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "18px",
              }}
            >
              <div
                style={{
                  width: "55px",
                  height: "55px",
                  borderRadius: "50%",
                  background:
                    "linear-gradient(to bottom right, #f59e0b, #fbbf24)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#fff",
                  fontSize: "22px",
                }}
              >
                ☎
              </div>

              <div>
                <h4
                  style={{
                    margin: 0,
                    fontSize: "18px",
                    color: "#111827",
                    marginBottom: "4px",
                  }}
                >
                  Phone
                </h4>

                <p
                  style={{
                    margin: 0,
                    color: "#6b7280",
                  }}
                >
                  +91 XXXXX XXXXX
                </p>
              </div>
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "18px",
              }}
            >
              <div
                style={{
                  width: "55px",
                  height: "55px",
                  borderRadius: "50%",
                  background:
                    "linear-gradient(to bottom right, #16a34a, #22c55e)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#fff",
                  fontSize: "22px",
                }}
              >
                📍
              </div>

              <div>
                <h4
                  style={{
                    margin: 0,
                    fontSize: "18px",
                    color: "#111827",
                    marginBottom: "4px",
                  }}
                >
                  Location
                </h4>

                <p
                  style={{
                    margin: 0,
                    color: "#6b7280",
                  }}
                >
                  Hyderabad, Telangana, India
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* MAP CARD */}
        <div
          className="map-container"
          style={{
            overflow: "hidden",
            borderRadius: "24px",
            boxShadow: "0 20px 50px rgba(0,0,0,0.08)",
            background: "#fff",
            padding: "12px",
          }}
        >
          <iframe
            width="100%"
            height="450"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3806.3530824934405!2d78.4890415743578!3d17.442806683453846!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb9a10d7eab687%3A0x72205daaccbbc186!2sAshoka%20Bhoopal%20Chambers%2C%20Sardar%20Patel%20Rd%2C%20Kalasiguda%2C%20Secunderabad%2C%20Telangana%20500003!5e0!3m2!1sen!2sin!4v1734348718289!5m2!1sen!2sin"
            style={{
              border: 0,
              borderRadius: "18px",
            }}
            allowFullScreen=""
            loading="lazy"
            title="map"
          ></iframe>
        </div>
      </div>
    </div>
  </div>
);
};

export default ContactForm;
